import { gql } from "@apollo/client";

export const APPROVE_INVOICES = gql`
  mutation approveInvoices($input: ApproveInvoicesInput!) {
    invoice {
      approveInvoices(input: $input) {
        invoiceId
        errorMessage
        success
      }
    }
  }
`;
